import { render, staticRenderFns } from "./VerifyMsgDialog.vue?vue&type=template&id=39abaa7e&scoped=true"
import script from "./VerifyMsgDialog.vue?vue&type=script&lang=js"
export * from "./VerifyMsgDialog.vue?vue&type=script&lang=js"
import style0 from "./VerifyMsgDialog.vue?vue&type=style&index=0&id=39abaa7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abaa7e",
  null
  
)

export default component.exports